import React from 'react';
import Row from "@Containers/components/Row";
import IconFilterWithCount from "@Icons/IconFilterWithCount";
import Translation from "@Translation/components/Translation";
import Filters from "@SearchResults/features/sidebar/components/Filters";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import ParamsType from "@SearchResults/types/params/Params.type";

type FiltersContainerProps = {
    searchData: SearchResultsRtkQueryResponseType
    params: ParamsType
}

function FiltersContainer({searchData, params}: FiltersContainerProps) {
    return (
        <div className="gb--sidebar-section gb--sidebar-section-filters">
            <Row center className="gb--sidebar-section-title">
                <Row center className="gb--sidebar-section-title_wrapper">
                    <div className="icon-container">
                        <IconFilterWithCount
                            width="25"
                            height="25"
                        />
                    </div>
                    <h3>
                        <Translation translationKey="search_results.filter_by.label"/>
                    </h3>
                </Row>
            </Row>
            <div className="gb--sidebar-section-content">
                <Filters
                    searchData={searchData}
                    params={params}
                />
            </div>
        </div>
    );
}

export default FiltersContainer;